module.exports = __webpack_public_path__ + "img/5.3.faf67c9f.jpg";